import React, { Component } from 'react';

//Country List
const CountryList = ({ data, listId, marginApplicable, pageJson, translations, accountCountryList, getProductRelatedTaxonomy }) => (
  <div className="ie-tier-section">
    <div className="ie-tier-section__content" key={listId} >
      <dl className="ie-tier-section__content__list">
        <dt>{`${translations(pageJson.account)} ${listId + 1}:`}</dt>
        <dd>
          {data.account ?
            <div style={{ display: 'table-row' }}>
              <span>{data.account.accountType !== undefined ? accountCountryList ? getProductRelatedTaxonomy(data.account).accountType.name + ',' : data.account.accountType.name : ''}</span>
              <span>{data.account.accountNumber !== undefined && data.account.accountNumber !== '' ? data.account.accountNumber + ',' : ''}</span>
              <span>{data.account.branchCode !== undefined && data.account.branchCode !== '' ? data.account.branchCode + ',' : ''}</span>
              <span>{data.account.country !== undefined ? accountCountryList ? getProductRelatedTaxonomy(data.account).country.name + ',' : data.account.country.name + ',' : ''}</span>
              <span>{data.account.currency !== undefined ? data.account.currency.name : ''}</span>
              <br />
              <span>{data.account.accountHolder !== undefined ? data.account.accountHolder.name : ''}</span>
              <br />
              <span>{data.account.hsbcBankName !== undefined ? data.account.hsbcBankName.name + ',' : ''}</span>
              <span>{data.account.bankName !== undefined ? data.account.bankName + ',' : ''}</span>
              <span>{data.account.accountTitle !== undefined ? data.account.accountTitle : ''}</span>
              <span>{data.account.tempRefrenceId !== undefined && data.account.tempRefrenceId !== '' ? `(${data.account.tempRefrenceId})` : ''}</span>
            </div>
            : null}
        </dd>
      </dl>
      {
        marginApplicable === true
          ? <dl className="ie-tier-section__content__list">
            <dt>{`${translations(pageJson.title)} :`}</dt>
            {
              <dd>{data.premiumMargin === true ? 'Yes' : 'No'}</dd>
            }
          </dl>
          : ''
      }

    </div>
  </div>
)

// Country And Account Section
class CountryAndAccount extends Component {

  render() {
    const { pageJson, translations } = this.props;
    if (pageJson !== undefined) {
      return (
        <div className="ie-detail-container">
          <div className="ie-detail-container__heading">{`2. ${translations(pageJson.pageHeading)}`}</div>
          <div className="ie-detail-container__content">
            {
              this.props.data.interestEnhancement !== undefined
                ? this.props.data.interestEnhancement.countryAndAccount.map((item, key) => {
                  return (
                    <div>
                      <dl
                        className="ie-detail-container__horizontal-row ie-detail-container__navigate"
                      >
                        <dt>{this.props.countryList ? this.props.getCountryTaxonomy(item).country.name : item.country.name}</dt>
                        <dd>{`${item.accounts.length} accounts (${item.accounts.filter(key => key.premiumMargin).length} premium)`}</dd>
                      </dl>
                      {
                        item.accounts.map((item, key) =>
                          <CountryList
                            data={item}
                            listId={key}
                            marginApplicable={this.props.data.marginApplicable}
                            pageJson={pageJson}
                            translations={(word) => translations(word)}
                            accountCountryList={this.props.accountCountryList}
                            getProductRelatedTaxonomy={(item) => this.props.getProductRelatedTaxonomy(item)}
                          />
                        )
                      }
                    </div>
                  )
                })
                : ''
            }
          </div>
        </div>
      )
    } else {
      return null
    }
  }
}

export default CountryAndAccount;



// WEBPACK FOOTER //
// ./src/components/CaseList/PreviewGLS/IEPreview/CountryAndAccount.js